import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { Header as ModalHeader } from "@/components/Header";
import { Flex, Header, Img } from "@/eworkitComponents";
import { EmailMessage, IWithEmailResendProps, withEmailResend } from "@/views/Session/components/EmailMessage";

import EmailSentImg from "./email-sent.svg";

const EmailSentComponent: FunctionComponent<IWithEmailResendProps> = props => {
  const { t } = useTranslation("public");

  return (
    <EmailMessage {...props}>
      <Flex direction="column" innerMargin="lg" align="center">
        <ModalHeader size="lg" weight="bold" color="black" align="center">
          {t("SESSION_SIGNUP.USER_FORM.EMAIL_VERIFICATION")}
        </ModalHeader>
        <Img src={EmailSentImg} />
        <Header size="xs" align="center">
          {t("SESSION_EMAIL.HEADER", { value: props.email })}
        </Header>
        <Header size="xs" align="center">
          {t("SESSION_EMAIL.TEXT")}
        </Header>
      </Flex>
    </EmailMessage>
  );
};

export const ConfirmEmail = withEmailResend(EmailSentComponent);
